import AdministratorsApi from '../../../../core/api/AdministratorsApi'
const api = new AdministratorsApi()

export const events = {
  setting: {
    firstName: 'ADMINISTRATOR_ADD_SET_FIRST_NAME',
    lastName: 'ADMINISTRATOR_ADD_SET_LAST_NAME',
    emailAddress: 'ADMINISTRATOR_ADD_SET_EMAIL_ADDRESS'
  },
  submit: {
    administrator: 'ADMINISTRATOR_ADD_SUBMIT'
  },
  submitting: {
    administrator: 'ADMINISTRATOR_ADD_SUBMITTING'
  },
  submitted: {
    administrator: 'ADMINISTRATOR_ADD_SUBMITTED'
  },
  resetPassword: {
    administrator: 'ADMINISTRATOR_RESET_PASSWORD'
  }
}

export const actions = {
  setting: {
    firstName: (validationResult, firstName) => ({
      type: events.setting.firstName,
      firstName,
      validationResult
    }),
    lastName: (validationResult, lastName) => ({
      type: events.setting.lastName,
      lastName,
      validationResult
    }),
    emailAddress: (validationResult, emailAddress) => ({
      type: events.setting.emailAddress,
      emailAddress,
      validationResult
    })
  },
  submit: {
    administrator: () => ({
      type: events.submit.administrator
    }),
    newAdministrator: (administrator) => {
      const administratorRequest = api.postAdministrator(administrator)

      return (dispatch) => {
        dispatch({ type: events.submitting.administrator })
        administratorRequest.then(function (response) {
          dispatch(api.handleResponse(events.submitted.administrator, response))
          api.resetPassword(administrator.emailAddress).then(function (res) {
            dispatch(api.handleResponse(events.resetPassword.administrator, response))
          })
        })
      }
    }
  }
}
